import { boolean, InferType } from 'yup';
import { yupEnum, yupObject, yupString } from 'shared/utils/YupUtils';
import {
  BankAccountVerificationMethodType,
  BankAccountVerificationStatusType,
} from 'shared/modules/superpay/SuperPayDTO';

export interface BankAccountVerificationResult {
  status: BankAccountVerificationStatusType;
  verificationMethod: BankAccountVerificationMethodType | null;
}

export type ChangeBankAccountStep = InferType<
  typeof changeBankAccountStepSchema
>;
export const changeBankAccountStepSchema = yupEnum([
  'bank-info',
  'confirm',
  'verify',
] as const);

export type SubmittedBankAccount = InferType<typeof submittedBankAccountSchema>;
export const submittedBankAccountSchema = yupObject({
  holderName: yupString(),
  routingNumber: yupString(),
  accountNumber: yupString(),
});

export type ChangeBankAccountStepState = InferType<
  typeof changeBankAccountStepStateSchema
>;
export const changeBankAccountStepStateSchema = yupObject({
  isSubmitting: boolean().defined(),
  hasUnsavedChanges: boolean().defined(),
});
